const PROVINCES = "Provinces";
const MUNICIPALITIES = "municipalities";
const DISTRICTS = "districts";
const SECTIONS = "sections";

export { PROVINCES, MUNICIPALITIES, DISTRICTS, SECTIONS };
